







import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class Tag extends Vue {
  @Prop({ default: "normal" })
  private size?: string;
  @Prop({ default: "" })
  private type?: string;
}
